export function otherInput() {
    const _document = this._document;
    const selects = _document.querySelectorAll("select");
    const isDesktop = !this.isTouch;
    [...selects].forEach((item) => {
        item.addEventListener("change", (event) => {
            const select = event.target;
            const otherInput = isDesktop ? select.parentNode.nextElementSibling : select.parentNode.parentNode.nextElementSibling;
            console.log("OTHER: ", otherInput);
            if(select.value.toLowerCase() === "other") {
                otherInput.classList.add("visible");
            } else {
                otherInput.classList.remove("visible");
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/other-input.js